/**
 * Sends a log message to the server-side /api/log endpoint.
 * 
 * @param level The severity level of the log ('log', 'warn', 'error').
 * @param message The main log message string.
 * @param data Optional additional data to include with the log.
 */
export async function logToServer(
  level: 'log' | 'warn' | 'error' | 'info',
  message: string,
  data?: object
) {
  // Prevent logging on server-side rendering, only run in browser
  // if (typeof window === 'undefined') {
  //   return;
  // }

  try {
    // Include the current browser URL automatically for context
    const logPayload = {
      level,
      message,
      data: { 
        ...(data || {}), 
        url: window.location.href 
      },
      timestamp: new Date().toISOString(),
    };

    // Use fetch to send the log data.
    // `keepalive: true` helps ensure the request is sent even if the page is navigating away.
    await fetch('/api/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(logPayload),
      keepalive: true, 
    });
  } catch (error) {
    // Fallback to console.error if sending the log fails
    console.error('Failed to send log to server:', error);
  }
} 